import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ThreeColumnsContainer from '../../../generic-components/Layout/ThreeColumnsContainer';
import TaxBucketBalance from '../components/TaxBucketBalance';
import TaxBucketLatestTransactions from '../components/TaxBucketLatestTransactions';
import TaxBucketAutoSaving from '../components/TaxBucketAutoSaving';
import { POPUP_LIFESPAN } from '../../emergencyBucketDashboard/constants';
import { SUB_PATHS, TAX_BUCKET_DASHBOARD } from '../constants';
import UpperMessagePopUp from '../../transactions/components/UpperMessagePopUp';
import moneyMovementIcon from '../../../assets/icons/svg/colored-icons/ic-colored-success.svg';
import { validateFeatureFlag } from '../../../services/featureFlagService';
import { FEATURE_FLAG } from '../../../constants/general';
import { VIEWS_MAP } from '../../../router/constants';
import PageLayout from '../../../generic-components/PageLayout/PageLayout';
import PageHeader from '../../../generic-components/PageHeader/PageHeader';

const TaxBucketDashboard = () => {
  const { ADD_PATH, WITHDRAW_PATH, TAX_BUCKET_ACTIVATED } = SUB_PATHS;
  const { CHANGED, ACTIVATED_1, ACTIVATED_2 } = TAX_BUCKET_DASHBOARD.POPUP_SUCCESS;
  const navigate = useNavigate();
  const params = useParams();
  const paramsArr = params.main?.split('-');
  const [showPopup, setShowPopup] = useState<boolean>(false);
  const closePopup = () => {
    setShowPopup(false);
    window.history.replaceState(null, '', '/tax-bucket-dashboard/:main');
  };

  const { t } = useTranslation();

  const getPopupMessage = () => {
    if (paramsArr && paramsArr.length > 0) {
      if (paramsArr[0] === TAX_BUCKET_ACTIVATED && paramsArr[1] === 'true') {
        if (paramsArr.length > 2 && paramsArr[2] === 'true') return t(CHANGED);
        if (paramsArr.length === 4 && paramsArr[2] === 'false') {
          return `${t(ACTIVATED_1)}${(parseFloat(paramsArr[3]) * 100).toFixed(0)}${t(ACTIVATED_2)}`;
        }
      }
    }
    return '';
  };

  useEffect(() => {
    if (!validateFeatureFlag(FEATURE_FLAG.TAX_BUCKET)) navigate(`/${VIEWS_MAP.DASHBOARD}`);
    if (paramsArr && paramsArr.length > 0) {
      if (paramsArr[0] === WITHDRAW_PATH || paramsArr[0] === ADD_PATH || paramsArr[0] === TAX_BUCKET_ACTIVATED) {
        setShowPopup(true);
        setTimeout(() => {
          closePopup();
        }, POPUP_LIFESPAN);
      }
    }
  }, []);

  return (
    <PageLayout>
      <PageHeader title={t(TAX_BUCKET_DASHBOARD.PAGE_HEADER)} pathToNavigate={`/${VIEWS_MAP.DASHBOARD}`} />
      {showPopup && paramsArr && paramsArr.length > 0 && (
        <UpperMessagePopUp iconSource={moneyMovementIcon} handleClose={closePopup} messageText={getPopupMessage()} />
      )}
      <div className='w-full h-full flex gap-[24px]'>
        <ThreeColumnsContainer
          firstColumnClassname='basis-[50%] flex flex-col min-w-[528px] max-w-[100%] gap-[24px]'
          firstColumnChildren={[<TaxBucketBalance />, <TaxBucketAutoSaving />]}
          secondColumnClassname='basis-[50%] min-w-[528px] max-w-[100%]'
          secondColumnChildren={[<TaxBucketLatestTransactions />]}
        />
      </div>
    </PageLayout>
  );
};

export default TaxBucketDashboard;
